<div class="app">
  <div class="childs flex-grow-1" [ngStyle]="{ 'margin-left': fromConfigurator == false ? '1%' : '0' }">
    <mat-tab-group
          mat-stretch-tabs="false"
          mat-align-tabs="start"
          [(selectedIndex)]="currentActiveIndex"
        >
      <!-- <mat-tab label="Registries" (click)="setActiveTab('registries')">
        <app-registry-management></app-registry-management>
      </mat-tab> -->
      <!-- <mat-tab label="Image Repositories" (click)="setActiveTab('repositories')">
        <app-repository-management></app-repository-management>
      </mat-tab> -->
      <mat-tab label="Images" (click)="setActiveTab('images')">
        <app-image-management></app-image-management>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>